import React from 'react';
import logo from '../../assets/img/logo-compras.png';


const  Compras = ()=>{
    return <div style={{ textAlign:'center', paddingTop:'50px' }}><img alt='logo' src={logo } style={{maxWidth:'80%'}} /></div>;
};

export default Compras;
